import { useEffect } from 'react'
import { toaster } from '@/components/ui/toaster'
import { extractApiMessage } from '../lib/apiError'

/**
 * SC-5a: for a background `useQuery` whose failure has no natural inline home (a fly-to, an
 * optional overlay). Toasts the server's message once per distinct error object. TanStack keeps
 * the same `error` reference across re-renders until the next failure, so the effect does not
 * refire on every render. Pass string-literal title/fallback so the deps stay stable.
 */
export function useErrorToast(error: unknown, title: string, fallback: string): void {
  useEffect(() => {
    if (!error) return
    toaster.create({
      title,
      description: extractApiMessage(error, fallback),
      type: 'error',
      duration: 6000,
      closable: true,
    })
  }, [error, title, fallback])
}
